import Translation from "components/Translation"
import getConfig from "next/config"
import { useState } from "react"
import { CategoryApiOutput } from "types/category"

type CategoryEntry = {
    name: string
}

type CategoryCardPreviewProps = {
    category: CategoryApiOutput
    fallback_img?: string
    entry_list: CategoryEntry[]
    primary_color: string
    show_services_include: boolean
    setSelectedCategory(category: CategoryApiOutput): void
}

export default function CategoryCardPreview(props: CategoryCardPreviewProps) {
    const {
        entry_list,
        primary_color,
        category,
        fallback_img,
        show_services_include,
        setSelectedCategory
    } = props
    const [is_hover, toggleHover] = useState<boolean>(false)
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    const serviceSize = 3
    const remainingItems =
        entry_list?.length > serviceSize
            ? entry_list?.length - serviceSize
            : 0

    return (
        <>
            <div
                className="w-[56px] flex items-center flex-col cursor-pointer px-[5px] py-[3px] gap-[2px] rounded-[2px] shadow-[4px]"
                onClick={() => {
                    setSelectedCategory(category)
                }}
                onMouseEnter={() => {
                    toggleHover(true)
                }}
                onMouseLeave={() => {
                    toggleHover(false)
                }}
                style={{
                    backgroundColor: is_hover
                        ? primary_color
                        : `rgb(249 250 251)`,
                    borderColor: is_hover
                        ? `${primary_color}40`
                        : 'transparent',
                }}
            >
                <h1
                    className={`${is_hover ? 'text-white' : 'text-primary'} text-[4px] font-medium `}
                >
                    {category?.name}
                </h1>
                <div className="flex flex-col items-center gap-2 ">
                    <img
                        src={
                            category?.imageUrl ||
                            fallback_img ||
                            `https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/location/location_fallback.jpg`
                        }
                        className="h-[28px] w-full "
                        alt="Category Image"
                    />
                    {show_services_include &&
                        <p className={`${is_hover ? 'text-white' : ''} mt-[2px] text-[3px]`}>
                            <Translation
                                content_key={
                                    'services_include' || 'serivices include:'
                                }
                            />{' '}
                            &nbsp;
                            {entry_list?.map(
                                (item: CategoryEntry, index: number) =>
                                    index <= serviceSize && (
                                        <span key={index}>{item.name}, &nbsp;</span>
                                    )
                            )}
                            {remainingItems > 0 &&
                                <span
                                    className={`  ${is_hover ? 'text-white' : ' text-sky-200'}`}
                                >
                                    <Translation
                                        content_key="booking.x_items_more"
                                        content_values={{
                                            remaining_count: remainingItems
                                        }}
                                    />
                                </span>
                            }
                        </p>
                    }
                </div>
            </div>
        </>
    )
}